(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-creator-grid"] && !Shopify.designMode) return;
  try {
    
  /**
   * Swipeable creator track with optional arrow navigation.
   *
   * Progressive enhancement: the track is already swipeable with CSS scroll
   * snap, so this class only adds arrow paging plus a focusable scroll region
   * for keyboard users. Arrows stay hidden until the track really overflows,
   * which means the same markup is correct on desktop grid, tablet carousel
   * and mobile carousel without any breakpoint logic in JS.
   *
   * Implemented as a custom element so every section instance owns its
   * listeners and tears them down on shopify:section:unload.
   */
  class CnCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cn-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-cn-prev]');
      this.nextButton = this.querySelector('[data-cn-next]');

      this.handleScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.handlePrev = () => this.page(-1);
      this.handleNext = () => this.page(1);

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.handleScroll);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      } else {
        window.removeEventListener('resize', this.handleScroll);
      }
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    /* Advance by one tile so the snap points and the arrows agree. */
    page(direction) {
      const item = this.track.querySelector('li');
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: step * direction,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    update() {
      const overflowing = this.maxScroll > 2;

      this.toggleAttribute('data-cn-ready', overflowing);

      /* A scrollable region needs to be reachable by keyboard (WCAG 2.1.1),
         but adding a permanent tab stop to a non-scrolling grid would be noise. */
      if (overflowing) {
        this.track.setAttribute('tabindex', '0');
      } else {
        this.track.removeAttribute('tabindex');
      }

      if (!this.prevButton || !this.nextButton) return;

      /* Math.abs keeps this correct in right-to-left locales. */
      const position = Math.abs(this.track.scrollLeft);

      this.prevButton.disabled = !overflowing || position <= 2;
      this.nextButton.disabled = !overflowing || position >= this.maxScroll - 2;
    }
  }

  if (!customElements.get('cn-carousel')) {
    customElements.define('cn-carousel', CnCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Reveals the mobile sticky CTA once the hero scrolls out of view.
   * Implemented as a custom element so each section instance manages its own
   * observer and cleans up on shopify:section:unload.
   */
  class CnStickyCta extends HTMLElement {
    connectedCallback() {
      const targetId = this.getAttribute('data-observe');
      const target = targetId ? document.getElementById(targetId) : null;

      if (!target || typeof IntersectionObserver === 'undefined') {
        this.setAttribute('data-visible', '');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.toggleAttribute('data-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!customElements.get('cn-sticky-cta')) {
    customElements.define('cn-sticky-cta', CnStickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  }

  customElements.define('sticky-header', StickyHeader);

  if (!window.EGHeaderAccountMenuEventsBound) {
    window.EGHeaderAccountMenuEventsBound = true;

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.header-account-menu[open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.header-account-menu[open]').forEach((menu) => {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
